import { XIcon } from './Layout';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    ReferenceLine
} from 'recharts';

interface MarketTrendModalProps {
    isOpen: boolean;
    onClose: () => void;
    data: any[];
    type: 'FEAR_GREED' | 'KOSPI' | 'KOSDAQ';
}

export default function MarketTrendModal({ isOpen, onClose, data, type }: MarketTrendModalProps) {
    if (!isOpen) return null;

    const getTitle = () => {
        switch (type) {
            case 'FEAR_GREED': return 'Fear & Greed Index 추세 (30일)';
            case 'KOSPI': return 'KOSPI 수급 추세 (30일)';
            case 'KOSDAQ': return 'KOSDAQ 수급 추세 (30일)';
            default: return '';
        }
    };

    const formatXAxis = (tickItem: string) => {
        // MM.DD format
        const date = new Date(tickItem);
        return `${date.getMonth() + 1}.${date.getDate()}`;
    };

    const renderChart = () => {
        if (type === 'FEAR_GREED') {
            return (
                <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <XAxis dataKey="date" tickFormatter={formatXAxis} />
                        <YAxis domain={[0, 100]} />
                        <Tooltip labelFormatter={(label) => new Date(label).toLocaleDateString()} />
                        <ReferenceLine y={25} stroke="red" strokeDasharray="3 3" label={{ value: 'Extreme Fear', position: 'insideTopLeft', fill: 'red', fontSize: 10 }} />
                        <ReferenceLine y={75} stroke="green" strokeDasharray="3 3" label={{ value: 'Extreme Greed', position: 'insideBottomLeft', fill: 'green', fontSize: 10 }} />
                        <Line type="monotone" dataKey="fearGreedValue" stroke="#8884d8" strokeWidth={2} dot={{ r: 3 }} activeDot={{ r: 6 }} name="Index" />
                    </LineChart>
                </ResponsiveContainer>
            );
        } else {
            // Supply Demand Chart
            const foreignKey = type === 'KOSPI' ? 'kospiForeignNet' : 'kosdaqForeignNet';
            const institutionKey = type === 'KOSPI' ? 'kospiInstitutionNet' : 'kosdaqInstitutionNet';

            return (
                <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <XAxis dataKey="date" tickFormatter={formatXAxis} />
                        <YAxis />
                        <Tooltip labelFormatter={(label) => new Date(label).toLocaleDateString()} formatter={(value: number | undefined) => [value ? `${value.toLocaleString()}억` : '-', '']} />
                        <ReferenceLine y={0} stroke="#666" />
                        <Line type="monotone" dataKey={foreignKey} stroke="#ef4444" strokeWidth={2} dot={false} name="외국인" />
                        <Line type="monotone" dataKey={institutionKey} stroke="#3b82f6" strokeWidth={2} dot={false} name="기관" />
                    </LineChart>
                </ResponsiveContainer>
            );
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '600px', width: '90%' }}>
                <div className="modal-header">
                    <h2 className="modal-title">{getTitle()}</h2>
                    <button className="btn-icon" onClick={onClose}>
                        <XIcon />
                    </button>
                </div>

                <div className="modal-body" style={{ height: '350px' }}>
                    {data.length > 0 ? renderChart() : <div className="flex center h-full text-muted">데이터가 부족합니다</div>}
                </div>

                <div className="modal-footer">
                    <p className="text-sm text-muted text-center w-full">
                        {type === 'FEAR_GREED' ? '0-25: 극도 공포, 75-100: 극도 탐욕' : '단위: 억원'}
                    </p>
                </div>
            </div>
        </div>
    );
}
